import message from 'antd/lib/message';

export async function copyVenToClipboard(data: any) {
    let dataToCopy = `
Username: ${data.ven_username || ''},
Password: ${data.ven_password || ''},
VEN ID: ${data.ven_id || ''},
VTN ID: ${data.ven_vtn_id || ''},
VTN URL: ${data.ven_uri || ''}`;

    if ('ven_market_context' in data) {
        dataToCopy += `,
Market Context: ${data.ven_market_context || ''}`;
    }

    try {
        await navigator.clipboard.writeText(dataToCopy);
        message.success('VEN properties copied!');
    } catch (error: any) {
        message.error(error || 'Cannot copy VEN properties!');
    }
}
